import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Tab } from '@mui/material'
import React from 'react'
import AdminLayout from '../../components/admin/AdminLayout'
import { useTranslation } from 'react-i18next';
import LecturesCategoriesByAdmin from '../../components/admin/LecturesCategoriesByAdmin';
import LecturesCategoriesPendingByAdmin from '../../components/admin/LecturesCategoriesPendingByAdmin';

export default function AdminLectures() {
    const {t} = useTranslation()
    const [value, setValue] = React.useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <AdminLayout>
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label={t('Lectures')} value="1" />
                        <Tab label={t('pending lectures')} value="2" />
                    </TabList>
                </Box>
                    <TabPanel value="1"><LecturesCategoriesByAdmin/></TabPanel>
                    <TabPanel value="2"><LecturesCategoriesPendingByAdmin/></TabPanel>
                </TabContext>
        </AdminLayout>
    )
}